<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn @click="download" v-on="on" class="primary">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>Exportar</span>
    </v-tooltip>
    <table id="table-export" style="display:none" v-if="dataQuery == 2">
      <tr>
        <th>Número de empleado</th>
        <th>Nombre</th>
        <th>Correo Electrónico</th>
        <th>Puesto</th>
        <th>Clave de acceso</th>
        <th>Fecha de Resolución</th>
        <template v-if="participants[0].personalData && participants[0].personalData.gender">
          <th
            :key="`personal-data-head-personalData-${index}`"
            v-for="(personalData, index) in participants[0].personalData"
          >{{personalData.optionName}}</th>
        </template>
        <template v-else>
          <th :key="index" v-for="(a,index) in 13"></th>
        </template>
        <th :key="index" v-for="(a,index) in 20">Reactivo {{index + 1}}</th>
      </tr>
      <tr :key="'participant-' +participant.idParticipant" v-for="participant in  participants">
        <td>{{participant.work}}</td>
        <td>{{participant.name}}</td>
        <td>{{participant.email}}</td>
        <td>{{participant.position}}</td>
        <td>{{participant.password}}</td>
        <td>{{participant.resolved}}</td>
        <template v-if="participant.personalData && participant.personalData.gender">
          <td
            :key="`personal-data-${participant.idParticipant}-personalData-${index}`"
            v-for="(personalData, index) in participant.personalData"
          >{{personalData.option}}</td>
        </template>
        <template v-else>
          <td :key="index" v-for="(a,index) in 13">""</td>
        </template>

        <template
          v-if="questionnaires.find(quest=>quest.idParticipant == participant.idParticipant).questionnaire.length == 20"
        >
          <td
            :key="'quiestionnaire_'+index"
            v-for="(questionnaire,index) in questionnaires.find(quest=>quest.idParticipant == participant.idParticipant).questionnaire"
          >{{questionnaire.answer ? "Si":"No"}}</td>
        </template>
        <template
          v-else-if="questionnaires.find(quest=>quest.idParticipant == participant.idParticipant).questionnaire.length == 6"
        >
          <td
            :key="'quiestionnaire_'+index"
            v-for="(questionnaire,index) in questionnaires.find(quest=>quest.idParticipant == participant.idParticipant).questionnaire"
          >{{questionnaire.answer ? "Si":"No"}}</td>
          <td
            :key="'answers-participant'+participant.idParticipant + '-'+index"
            v-for="(a,index) in 14"
          >""</td>
        </template>
        <template v-else>
          <td
            :key="'answers-participant'+participant.idParticipant + '-'+index"
            v-for="(a,index) in 20"
          >""</td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      dataQuery: 0,
      host: process.env.VUE_APP_HOST,
      participants: [],
      questionnaires: []
    };
  },
  methods: {
    exportTableToCSV(filename) {
      var csv = [];
      var rows = document.querySelectorAll("table tr");

      for (var i = 0; i < rows.length; i++) {
        var row = [],
          cols = rows[i].querySelectorAll("td, th");

        for (var j = 0; j < cols.length; j++)
          row.push(cols[j].innerText.replace(/(\r\n|\n|\r)/gm, ""));

        csv.push(row.join(","));
      }

      // Download CSV file
      this.downloadCSV(csv.join("\r\n"), filename);
    },
    downloadCSV(csv, filename) {
      var csvFile;
      var downloadLink;

      // CSV file
      csvFile = new Blob([csv], { type: "text/csv" });

      // Download link
      downloadLink = document.createElement("a");

      // File name
      downloadLink.download = filename;

      // Create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);

      // Hide download link
      downloadLink.style.display = "none";

      // Add the link to DOM
      document.body.appendChild(downloadLink);

      // Click download link
      downloadLink.click();
    },
    download() {
      this.dataQuery = 0;
      this.getParticipants().then(() => {
        this.getQuestionnaires().then(() => {
          setTimeout(() => {
            this.exportTableToCSV("Empleados.csv");
          }, 500);
        });
      });
    },
    getQuestionnaires() {
      return new Promise(resolve => {
        let data = {
          idUser: sessionStorage.getItem("authorization")
        };

        this.questionnaires = [];

        axios
          .post(
            this.host + "/questionnaire/readAll.php",
            this.createFormData(data)
          )
          .then(response => {
            this.questionnaires = response.data.participants;
            this.dataQuery = this.dataQuery + 1;
            resolve();
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    getParticipants() {
      return new Promise(resolve => {
        let data = {
          idUser: sessionStorage.getItem("authorization"),
          personalData: true
        };

        this.participants = [];

        axios
          .post(this.host + "/participants/read.php", this.createFormData(data))
          .then(response => {
            this.participants = response.data.data;
            this.dataQuery = this.dataQuery + 1;
            resolve();
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>

<style>
</style>